module.exports = __webpack_public_path__ + "img/entity_dots.047a50ae.svg";